export default __webpack_public_path__ + "static/media/decada-0070-0005-min.323c790f.jpg";